<template>
  <div>
    <app-header />
    <main class="page-container">
      <random-music />
    </main>
    <app-footer />
  </div>
</template>

<script>
import AppHeader from "../../components/AppHeader.vue";
import AppFooter from "../../components/AppFooter.vue";
import RandomMusic from "../../components/RandomMusic.vue";

export default {
  name: "RandomMusicPage",
  components: {
    AppHeader,
    AppFooter,
    RandomMusic
  }
};
</script>
